// src/pages/MasterDataPage.jsx
import React from "react";
import { useParams, Navigate } from "react-router-dom";
import useAuthStore from "../store/useAuthStore";
import BuilderLayout from "../layout/builders/Layout";
import CustomerLayout from "../layout/customer/Layout";
import MasterDataDisplay from "../layout/common/MasterDataDisplay";
import ProjectBanner from "../layout/builders/ProjectBanner";

const MasterDataPage = () => {
  const { projectId } = useParams();
  const { userType, token } = useAuthStore();

  // Redirect to login if not authenticated
  if (!token || !userType) {
    return <Navigate to="/login" replace />;
  }

  // Determine which layout to use based on user type
  const Layout = userType === "customer" ? CustomerLayout : BuilderLayout;

  return (
    <div style={{ backgroundColor: "#E0E0E0" }}>
      <Layout>
        {/* Show ProjectBanner only for builders */}
        {userType === "builder" && (
          <ProjectBanner
            title={`Master Data for Project #${projectId}`}
            // imageUrl="https://via.placeholder.com/1200x300" // Or a relevant image
          />
        )}
        <div className="p-4">
          {projectId ? (
            <MasterDataDisplay projectId={projectId} />
          ) : (
            <p className="text-red-500 text-center">Invalid Project ID.</p>
          )}
        </div>
      </Layout>
    </div>
  );
};

export default MasterDataPage;